import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { AuthService } from '../../../auth/services/auth.service';
import { ErrorShellComponent } from '../../../layout/components/error-shell/error-shell.component';
import { ROUTES } from '../../../core/constants/routes.constants';

@Component({
  selector: 'app-access-denied',
  imports: [RouterLink, ErrorShellComponent, TranslatePipe],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  protected readonly authService = inject(AuthService);
  protected readonly routes = ROUTES;
}
